<template>
  <div>
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <good-table-column-search
              :moduleapi="`${baseApi}/phone-extension`"
              :columns="columns"
              routerpath="/master/hr/phoneextension"
              :formOptions="formOptions"
              title="Phone Extension"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import GoodTableColumnSearch from '@/components/GoodTableColumnSearch.vue'

const baseApi = process.env.VUE_APP_APIENDPOINT

export default {
  components: {
    GoodTableColumnSearch
  },
  data () {
    return {
      baseApi,
      columns: [
        { label: 'Label', field: 'label' },
        { label: 'Extension', field: 'extension' },
        { label: 'SIP Username', field: 'sip_username' },
        { label: 'Assigned User', field: 'user.fullname' },
        { label: 'Display Name', field: 'display_name' },
        { label: 'WSS Server', field: 'ws_server' },
        { label: 'SIP Domain', field: 'sip_domain' }
      ],
      formOptions: {
        formTitle: `${this.$route.query.id ? 'Edit Phone Extension' : 'Add Phone Extension'}`,
        submitRouterPath: '/master/hr',
        gridForm: true,
        method: 'post',
        action: 'add',
        url: `${baseApi}/phone-extension`,
        inputFields: [
          { label: 'Label', name: 'label', value: '', type: 'text', placeholder: 'Enter label', class: 'col-md-6', required: true },
          { label: 'Extension', name: 'extension', value: '', type: 'text', placeholder: 'Enter extension number', class: 'col-md-6', required: true },
          { label: 'SIP Username', name: 'sip_username', value: '', type: 'text', placeholder: 'Enter SIP username', class: 'col-md-6', required: true },
          { label: 'SIP Password', name: 'sip_password', value: '', type: 'password', placeholder: 'Enter SIP password', class: 'col-md-6', required: true },
          {
            label: 'Transport',
            name: 'transport',
            value: 'wss',
            type: 'dropdown',
            class: 'col-md-6',
            required: true,
            options: ['wss', 'ws', 'tcp', 'udp']
          },
          { label: 'WSS Server', name: 'ws_server', value: '', type: 'text', placeholder: 'pbx.example.com', class: 'col-md-6', required: false },
          { label: 'WSS Port', name: 'ws_port', value: 7443, type: 'number', placeholder: '7443', class: 'col-md-6', required: false },
          { label: 'Server Path', name: 'server_path', value: '/ws', type: 'text', placeholder: '/ws', class: 'col-md-6', required: false },
          { label: 'SIP Domain', name: 'sip_domain', value: '', type: 'text', placeholder: 'sip.example.com', class: 'col-md-6', required: false },
          { label: 'Display Name', name: 'display_name', value: '', type: 'text', placeholder: 'Enter display name', class: 'col-md-6', required: false },
          { label: 'Outbound Caller ID', name: 'outbound_caller_id', value: '', type: 'text', placeholder: 'Enter caller ID', class: 'col-md-6', required: false },
          { label: 'Incoming Numbers', name: 'incoming_numbers', value: '', type: 'text', placeholder: 'Comma separated numbers', class: 'col-md-12', required: false },
          { label: 'Settings JSON', name: 'settings', value: '{}', type: 'text', placeholder: '{"autoAnswer":false}', class: 'col-md-12', required: false },
          { label: 'Company', name: 'company_id', value: '', type: 'dropdown', class: 'col-md-4', dropdownname: 'name', url: 'getCompany', responseValue: 'id', options: [] },
          { label: 'Branch', name: 'branch_id', value: '', type: 'dropdown', class: 'col-md-4', dropdownname: 'name', url: 'getBranch', responseValue: 'id', options: [] },
          { label: 'Project', name: 'project_id', value: '', type: 'dropdown', class: 'col-md-4', dropdownname: 'projectname', url: 'getProject', responseValue: 'id', options: [] },
          { name: 'is_active', value: 1, type: 'hidden' },
          { name: 'is_default', value: 0, type: 'hidden' }
        ]
      }
    }
  }
}
</script>
